/** Master volume slider. */

import { Volume2 } from "lucide-react";

/** Props for the MasterVolume component. */
export type MasterVolumeProps = {
	readonly value: number;
	readonly onChange: (gain: number) => void;
};

export function MasterVolume({ value, onChange }: MasterVolumeProps) {
	return (
		<div className="control-group">
			<span className="control-label">
				<Volume2 size={14} />
				Volume
			</span>
			<div className="volume-control">
				<input
					type="range"
					min={0}
					max={1}
					step={0.01}
					value={value}
					onChange={(e) => onChange(Number(e.target.value))}
					aria-label="Master volume"
				/>
				<span className="volume-value">{Math.round(value * 100)}%</span>
			</div>
		</div>
	);
}
